export default __webpack_public_path__ + "static/media/warlocAbout.5d6fbd4a.jpg";